'use client';

import { LeverageFinancialsResult } from './types';
import { ToolsTranslations } from '@/lib/translations/types';

interface ResultsDisplayProps {
  result: LeverageFinancialsResult;
  translations: ToolsTranslations['leverageFinancials'];
  productPrice: number;
  financingLevel: number;
}

export default function ResultsDisplay({ result, translations, productPrice, financingLevel }: ResultsDisplayProps) {
  return (
    <div className="space-y-3">
      <div className="p-4 bg-blue-50 rounded-lg border border-blue-100">
        <div className="text-sm text-gray-600">{translations.resultLabel}</div>
        <div className="text-3xl font-bold text-blue-900">
          {result.leverage !== null ? `${result.leverage.toFixed(2)} ${translations.leverageSuffix}` : '—'}
        </div>
        {!result.isValid && (
          <div className="text-xs text-red-600 mt-2">
            {result.message ?? translations.invalid.generic}
          </div>
        )}
      </div>

      {result.isValid && result.leverage !== null && (
        <div className="p-4 bg-gray-50 rounded-lg border border-gray-200">
          <p className="text-sm font-medium text-gray-700 mb-3"><b>{translations.additionalInfo.title}</b></p>
          <div className="space-y-2 text-sm">
            <div className="flex justify-between">
              <span className="text-gray-600">{translations.additionalInfo.productPrice}:</span>
              <span className="font-medium">{productPrice.toLocaleString()} {translations.currencySuffix}</span>
            </div>
            <div className="flex justify-between">
              <span className="text-gray-600">{translations.additionalInfo.financingLevel}:</span>
              <span className="font-medium">{financingLevel.toLocaleString()} {translations.currencySuffix}</span>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}


